/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    // Get data suject
    getDataSubject() {
        return HttpService.get(environment.API_DS_INQUIRY + '/data-subject');
    },
    // Get data flow
    getDataFlow(params) {
        return HttpService.get(environment.API_DS_INQUIRY + '/data-flow', {
            params,
        });
    },
    // Get ROPA
    getRopa(params) {
        return HttpService.get(environment.API_DS_INQUIRY + '/ropa', {
            params,
        });
    },
    // Get category-personal-data
    getCategoryPersonalData() {
        return HttpService.get(
            environment.API_DS_INQUIRY + '/category-personal-data'
        );
    },
    getDataFlowRopa(params) {
        return HttpService.get(environment.API_DS_INQUIRY + '/data-flow-ropa', {
            params,
        });
    },

    // Export data flow
    exportDataFlow(params) {
        return HttpService.get(
            environment.API_DS_INQUIRY + '/data-flow/export',
            {
                params,
                responseType: 'blob',
            }
        );
    },

    // Export ROPA
    exportRopa(params) {
        return HttpService.get(environment.API_DS_INQUIRY + '/ropa/export', {
            params,
            responseType: 'blob',
        });
    },

    // Export data flow ROPA
    exportDataFlowRopa(params) {
        return HttpService.get(
            environment.API_DS_INQUIRY + '/data-flow-ropa/export',
            {
                params,
                responseType: 'blob',
            }
        );
    },
};
